import { useMutation, useQueryClient } from "react-query";
import { Extraction, ExtractionDataItem, ExtractionFieldEditRequest } from "./types";
import { post } from "./api";

export function useUpdateExtractionField() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      extractionId,
      key,
      value,
      tableKey,
      tableRowIndex,
    }: {
      extractionId: string;
      key: string;
      value: string;
      tableKey?: string;
      tableRowIndex?: number;
    }) => {
      const endpoint = `extraction/${extractionId}/field/edit`;
      const body: ExtractionFieldEditRequest = { key, value };
      if (tableKey !== undefined) body.table_key = tableKey;
      if (tableRowIndex !== undefined) body.table_row_index = tableRowIndex;
      const { data: newDataItem } = await post(endpoint, body);
      return newDataItem;
    },
    {
      onSuccess: (newDataItem: ExtractionDataItem, { extractionId, key, tableKey, tableRowIndex }) => {
        queryClient.setQueryData<Extraction | undefined>(["extraction", extractionId], (oldData) => {
          if (oldData) {
            if (tableKey && tableRowIndex !== undefined) {
              // Update table cell
              const updatedTableData = [...(oldData.data[tableKey].table_data || [])];
              updatedTableData[tableRowIndex] = {
                ...updatedTableData[tableRowIndex],
                [key]: newDataItem,
              };
              return {
                ...oldData,
                data: {
                  ...oldData.data,
                  [tableKey]: {
                    ...oldData.data[tableKey],
                    table_data: updatedTableData,
                  },
                },
              };
            } else {
              // Update regular field
              return {
                ...oldData,
                data: {
                  ...oldData.data,
                  [key]: newDataItem,
                },
              };
            }
          }
          return oldData;
        });
      },
    }
  );
}
